import API from 'util/API';

export const getSupportDevices = async (restaurantId) => {
  const response = await API.get('/support/devices', {
    params: { restaurantId },
  });
  const data = response.data;
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.devices)) return data.devices;
  return [];
};

export const postSupportCommand = async (payload) => {
  const response = await API.post('/support/commands', payload);
  return response.data;
};

export const getSupportCommandStatus = async (commandId, { restaurantId, deviceId } = {}) => {
  const response = await API.get(`/support/commands/${commandId}`, {
    params: { restaurantId, deviceId },
  });
  return response.data;
};

export const getSupportAuditFeed = async (params) => {
  const response = await API.get('/support/audit', { params });
  return response.data;
};

export const uploadMenuFile = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await API.post('/support/menu-uploads', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const grantSupportRole = async ({ uid, email, action }) => {
  const response = await API.post('/support/grant-role', { uid, email, action });
  return response.data;
};

export const searchRestaurants = async (query) => {
  const response = await API.get('/restaurants/search', { params: { search: query } });
  return response.data;
};
